/**
 * 可控制的模块，功能或入口，true启用，false屏蔽
 * 通过配置kae构建参数：KAE_CONFIGS = '{`modules`:{`download`:false,`saveas`:true}}' 启用或屏蔽
 * kae配置会覆盖下面的默认设置
 */
const defaultModules = {
  login: true, // 登录
  share: true, // 分享
  sendToPhone: true, // 发送到手机
  download: true, // 下载
  saveas: true, // 另存至
  openByWPS: true, // 用wps打开
  report: true, // 举报文件
  feedback: true, // 帮助与反馈
  toHome: true, // 跳转金山文档
  applyRecovery: true, // 申请恢复访问
  certify: true, //立即认证
  canBuy: true, // 可购买
}

export default Object.assign(defaultModules, (process.env.KAE_CONFIGS && process.env.KAE_CONFIGS.modules) || {})
